import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import {
  JobListResponseSchema,
  JobPostingSchema,
} from "@applicant-reviewer/api";

export interface JobPostingFilters {
  status?: string;
  location?: string;
  search?: string;
}

export function useJobPostings(filters?: JobPostingFilters) {
  const params = new URLSearchParams();
  if (filters?.status) params.set("status", filters.status);
  if (filters?.location) params.set("location", filters.location);
  if (filters?.search) params.set("search", filters.search);

  const queryString = params.toString();
  const path = queryString ? `/jobs?${queryString}` : "/jobs";

  return useQuery({
    queryKey: [...queryKeys.jobPostings.list(), filters ?? {}],
    queryFn: async () => {
      const res = await apiClient.get(path, JobListResponseSchema);
      return res.jobs;
    },
  });
}

export function useJobPosting(id: string) {
  return useQuery({
    queryKey: queryKeys.jobPostings.detail(id),
    queryFn: () => apiClient.get(`/jobs/${id}`, JobPostingSchema),
    enabled: Boolean(id),
  });
}
